
import React, { useState } from 'react'
import { CardElement, injectStripe } from 'react-stripe-elements'
import { default as toaster } from './Toasts'
import usePending from '@apex/lib/hooks/usePending'
import AddressInputs from './AddressInputs'
import TextInputField from './TextInputField'
import FormField from './FormField'
import Dialog from './Dialog'
import Button from './Button'
import Form from './Form'
import Box from './Box'

/**
 * CouponForm is a coupon form.
 */

export default function CouponForm({ onSubmit }) {
  const [pending, submit] = usePending(onSubmit)

  return <Form onSubmit={submit}>
    <Box paddingTop={8} paddingX={8}>
      <Form.Row>
        <TextInputField
          name="coupon"
          width="100%"
          label="Coupon"
          placeholder="discount-5748698B0"
          spellCheck={false} />
      </Form.Row>
    </Box>
    <Dialog.Actions>
      <Button name="op" value="cancel">Cancel</Button>
      <Button name="op" value="apply" theme="primary" pending={pending}>Apply</Button>
    </Dialog.Actions>
  </Form>
}

